/**
 * Строка таблицы, в которую по ошибке попали поля всей формы - защита, возможно удалить в будущем
 */
export function isLeakedFormRow(row: unknown): boolean {
  const f = (row as { fields?: unknown })?.fields
  if (!f || typeof f !== 'object' || Array.isArray(f)) return false
  return Object.prototype.hasOwnProperty.call(f, 'element_states')
}

/**
 * Убирает мусорные строки из UniDataTable перед refill
 */
export function stripLeakedFormRows(fieldData: unknown): unknown {
  if (!fieldData || typeof fieldData !== 'object' || (fieldData as { type?: string }).type !== 'UniDataTable') {
    return fieldData
  }
  const val = (fieldData as { value?: { rows?: unknown[]; empty?: boolean; [k: string]: unknown } }).value
  if (!val || typeof val !== 'object' || !Array.isArray(val.rows)) {
    return fieldData
  }
  const rows = val.rows
  const filtered = rows.filter((r) => !isLeakedFormRow(r))
  if (filtered.length === rows.length) {
    return fieldData
  }
  if (filtered.length === 0) {
    return fieldData
  }
  return {
    ...(fieldData as object),
    value: {
      ...val,
      rows: filtered,
      empty: filtered.length === 0,
    },
  }
}

/**
 *  Для multiselect/refill собираем одну строку таблицы
 */

function collectTypedScalarFields(
  map: Record<string, any> | null | undefined,
  skip: Set<string>,
  into: Record<string, any>,
): void {
  if (!map || typeof map !== 'object') return
  for (const [k, v] of Object.entries(map)) {
    if (skip.has(k)) continue
    if (k.endsWith('__action')) continue
    if (into[k] !== undefined) continue
    if (!v || typeof v !== 'object' || Array.isArray(v)) continue
    if (!('type' in v && 'value' in v)) continue
    if (v.type === 'UniDataTable') continue
    into[k] = v
  }
}

export function coalesceEmptyUniTable(
  mergedFields: Record<string, any>,
  tableFieldName: string,
  extraSources?: Array<Record<string, any> | null | undefined>,
): void {
  const entry = mergedFields[tableFieldName]
  if (!entry || typeof entry !== 'object' || entry.type !== 'UniDataTable') {
    return
  }
  const val = entry.value
  if (!val || typeof val !== 'object') {
    return
  }
  const rows = val.rows
  if (Array.isArray(rows) && rows.length > 0) {
    return
  }
  // Сервер явно вернул пустую таблицу (`empty: true`)
  if (val.empty === true) {
    return
  }

  const skip = new Set([
    tableFieldName,
    `${tableFieldName}__listbox`,
    `${tableFieldName}__items`,
  ])

  const rowFields: Record<string, any> = {}
  collectTypedScalarFields(mergedFields, skip, rowFields)
  for (const ex of extraSources || []) {
    collectTypedScalarFields(ex, skip, rowFields)
  }

  const hasId = rowFields._id?.value != null && rowFields._id?.value !== ''
  const innRaw = rowFields.inn?.value
  const hasInn = innRaw != null && String(innRaw).trim() !== ''
  const hasName = ['fullName', 'legalName', 'shortName'].some((nk) => {
    const x = rowFields[nk]?.value
    return x != null && String(x).trim() !== ''
  })

  const typedCount = Object.keys(rowFields).length
  if (!(hasId || hasInn || hasName || typedCount >= 4)) {
    return
  }

  mergedFields[tableFieldName] = {
    type: 'UniDataTable',
    value: {
      ...val,
      attributes: val.attributes ?? {},
      columns: Array.isArray(val.columns) ? val.columns : [],
      rows: [
        {
          fields: {...rowFields},
          errors: {},
          attributes: {},
        },
      ],
      empty: false,
    },
  }
}
